<template>
    <div class="assemble-order-detail">
        <div class="flex__column header">
            <div v-if="orders.status==2">
                <span class="fs_40 c_ff lh_50">拼团中,还差{{orders.rest_number}}人成团</span>
                <span class="fs_28 c_ff">&emsp;还剩{{hour}}小时{{minute}}分{{second}}秒</span>
            </div>
            <span class="fs_40 c_ff lh_50" v-else>{{orders.status_name}}</span>
            <span class="fs_28 c_ff lh_40">订单编号：{{orders.order_number}}</span>
        </div>
        <!-- 地址信息 -->
        <div class="flex__column address">
            <span class="fs_34 c_1a lh_50">{{orders.linkman}}&emsp;{{orders.mobile_phone}}</span>
            <span class="fs_28 c_66 lh_40">{{orders.province}}{{orders.city}}{{orders.area}}{{orders.address}}</span>
        </div>
        <!-- 商品列表 -->
        <div class="sale-box">
            <div class="flex sale__item" v-for="(item,index) in order_product" :key="index">
                <img :src="item.product_cover_img" alt="">
                <div class="flex__null__around sale__item__right">
                    <span class="fs_26 c_1a lh_36 ellipsis_two">{{item.product_name}}</span>
                    <span class="fs_22 c_98" v-if="item.product_sku_name">规格: {{item.product_sku_name}}</span>
                    <div class="flex__between">
                        <span class="fs_30 c_main"><span class="fs_22">¥</span>{{item.product_price}}</span>
                        <span class="fs_26 c_80">x{{item.number}}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 支付信息-->
        <div class="info-box">
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">商品总价</span>
                <span class="fs_26 c_4d">¥{{orders.total_price}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.freight!='0.00'">
                <span class="fs_26 c_80">运费</span>
                <span class="fs_26 c_4d">¥{{orders.freight}}</span>
            </div>
            <div class="flex__between__center info__item" v-else>
                <span class="fs_26 c_80">运费</span>
                <span class="fs_26 c_4d">{{orders.freight_name}}</span>
            </div>
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">实付款</span>
                <span class="fs_26 c_main">¥{{orders.pay_money}}</span>
            </div>
        </div>
        <div class="info-box">
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">支付方式</span>
                <span class="fs_26 c_4d">{{orders.pay_way_name}}</span>
            </div>
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">备注</span>
                <span class="fs_26 c_4d" v-if="orders.remark">{{orders.remark}}</span>
                <span class="fs_26 c_4d" v-else>暂无</span>
            </div>
            <div class="flex__between__center info__item">
                <span class="fs_26 c_80">下单时间</span>
                <span class="fs_26 c_4d">{{orders.order_time}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.pay_time">
                <span class="fs_26 c_80">付款时间</span>
                <span class="fs_26 c_4d">{{orders.pay_time}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.express_time">
                <span class="fs_26 c_80">发货时间</span>
                <span class="fs_26 c_4d">{{orders.express_time}}</span>
            </div>
            <div class="flex__between__center info__item" v-if="orders.confirm_time">
                <span class="fs_26 c_80">收货时间</span>
                <span class="fs_26 c_4d">{{orders.confirm_time}}</span>
            </div>
        </div>
        <!-- 底部操作 -->
        <div class="flex__end__center footer" v-if="orders.status!=6">
            <button class="hollow-btn" v-if="orders.status==1||orders.status==9" @click="cancel(orders.id)">取消订单</button>
            <button class="hollow-btn" v-if="orders.status==2" v-link="'/Assemble/RegimentDetail/'+orders.group_id ">拼团详情</button>
            <!-- <button class="solid-btn" v-if="orders.status==2" @click="share_show=!share_show">邀请参团</button> -->
            <button class="hollow-btn" v-if="orders.status==8||orders.status==5||orders.status==6" @click="del(orders.id)">删除订单</button>
            <button class="hollow-btn" v-if="orders.status==4||orders.status==5||orders.status==6" @click="setLogistics(orders.id)">查看物流</button>
            <button class="hollow-btn" v-if="orders.status==3" @click="refund(orders.id,)">申请退款</button>
            <button class="solid-btn" v-if="orders.status==5" v-link="'/Assemble/Evaluate/'+orders.id">评价</button>
            <button class="solid-btn" v-if="orders.status==4" @click="harvest(orders.id)">确认收货</button>
            <button class="solid-btn" v-if="orders.status==1" @click="pay(orders.id)">支付</button>
            <button class="solid-btn" v-if="orders.status==3" @click="remind(orders.id)">提醒发货</button>
        </div>
    </div>
</template>
<script>
export default {
    name: "AssembleOrderDetail",
    data(){
        return{
            refresh: false,
            orders:{},
            order_product:[],
            hour: '00',
            minute: '00',
            second: '00',
        }
    },
    methods:{
          // 提醒发货
        remind(id){
            this.axios.post('/wechat.php/Collage/submitOrderRemind',{
                user_id: localStorage.user_id,
                order_id: id
            }).then(
                res=>{
                    this.$dialog.alert({
                        message: res.data.message
                    })
                }
            )
        },
        // 取消订单
        cancel(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认取消该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderCancel',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 申请退款
        refund(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认申请退款该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderRefund',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 删除订单
        del(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认删除该订单？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderDelete',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                ) 
            }).catch(()=>{})
        },
        // 查看物流
        setLogistics(id){
            this.$store.commit('setLogistics','/wechat.php/Collage/getExpressData');
            this.$router.push('/Mall/Logistics/'+id);
        },
        // 确认收货
        harvest(id){
            this.refresh=false;
            this.$dialog.confirm({
                message: '确认收货？'
            }).then(() => {
                this.axios.post('/wechat.php/Collage/submitOrderConfirm',{
                    user_id: localStorage.user_id,
                    order_id: id
                }).then(
                    res=>{
                        this.refresh=true;
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                )
            }).catch(()=>{})
        },
        // 支付
        pay(id){
            this.axios.post('/wechat.php/Collage/submitOrderPay',{
                user_id:localStorage.user_id,
                order_id:id,
            }).then(
                res=>{
                    if(res.data.code==1){
                        let pay={};
                        pay.pay_parameters=res.data.data.pay_parameters;
                        pay.back_link='/Assemble/RegimentDetail/'+res.data.data.group_id;
                        this.$store.commit('setPay',pay);
                        this.$router.push('/Pay');
                    }else{
                        this.$dialog.alert({
                            message: res.data.message
                        })
                    }
                }
            )
        }         
    },
    mounted(){
        this.axios.post('/wechat.php/Collage/getOrderDetailData',{
            user_id: localStorage.user_id,
            order_id: this.$route.params.id
        }).then(
            res=>{
                this.orders=res.data.data.order;
                this.order_product=res.data.data.order_product;
                this.$wx.setConfig();
                this.$wx.share({
                    title: res.data.data.order_product[0].product_name, 
                    link:"https://ym.jucheng01.net/vue/Assemble/RegimentDetail/" + res.data.data.order_product[0].product_id,
                    imgUrl: res.data.data.order_product[0].product_cover_img 
                })
                // 倒计时
                if(this.orders.status==2){
                    let current_time = Date.parse(new Date()) / 1000;
                    var totalSecond = this.orders.end_time -current_time;
                    this.interval = setInterval(function () {
                        // 秒数
                        var second = totalSecond;
                        // 小时位
                        var hr = Math.floor((second) / 3600);
                        var hrStr = hr.toString();
                        if (hrStr.length == 1) hrStr = '0' + hrStr;

                        // 分钟位
                        var min = Math.floor((second - hr * 3600) / 60);
                        var minStr = min.toString();
                        if (minStr.length == 1) minStr = '0' + minStr;

                        // 秒位
                        var sec = second - hr * 3600 - min * 60;
                        var secStr = sec.toString();
                        if (secStr.length == 1) secStr = '0' + secStr;
                            this.hour=hrStr,
                            this.minute=minStr,
                            this.second=secStr,
                            totalSecond--;
                        if (totalSecond < 0) {
                            clearInterval(this.interval);
                            this.$toast('活动已结束');
                            this.hour='00';
                            this.minut='00';
                            this.second='00';
                        }
                    }.bind(this), 1000);
                }
            }
        )
    }
}
</script>
<style scoped>
.header{
    padding: 20px 30px;
    background: #F93A42;
}
.address{
    padding: 30px;
    background: #fff;
}
.sale-box{
    padding: 0 30px 30px;
    margin-top: 15px;
    background: #fff;
    overflow: hidden;
}
.sale__item{
    margin-top: 30px;
}
.sale__item:last-child{
    border: 0;
}
.sale__item img{
    width: 180px;
    height: 180px;
    border-radius: 10px;
}
.sale__item__right{
    /* width: 480px; */
    margin-left: 30px;
}
.info-box{
    padding: 10px 30px;
    margin-top: 15px;
    background: #fff;
}
.info__item{
    height: 60px;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    padding: 0 30px;
    background: #fff;
}
.footer button{
    height: 55px;
    padding: 0 30px;
    border-radius:30px;
    margin-left: 10px;
}
.footer .hollow-btn{
    background: none;
    border: 2px solid #e6e6e6;
    font-size: 26px;
    color: #808080;
}
.footer .solid-btn{
    background: #F93A42;
    font-size: 26px;
    color: #fff;
}
</style>





// WEBPACK FOOTER //
// src/pages/assemble/OrderDetail.vue